import { createStyles, Theme } from '@material-ui/core';

export const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
      padding: theme.spacing(2)
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500]
    },
    dialogActionsRoot: {
      margin: '14px'
    },
    dropZone: {
      minHeight: '170px',
      height: '210px'
    },
    previewChip: {
      minWidth: 160,
      maxWidth: 210
    }
  });
